import React from "react";
import PropTypes from "prop-types";
import "./ListBox.css";

export default function ListBox({ label, items, cost, className, noItems }) {
  return (
    <div className={className}>
      <span className="checkbox-label">{label}</span>
      {items && items.length > 0 ? (
        <ul>
          {items.map(item => {
            return (
              <li key={item.food ? item.food : item.key ? item.key : item}>
                {item.food ? item.food : item}
              </li>
            );
          })}
        </ul>
      ) : <span><br></br>{noItems}</span>}
      {cost && <span className="food-cost"> - {cost}</span>}
    </div>
  );
}

ListBox.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array,
  cost: PropTypes.string,
  className: PropTypes.string.isRequired,
  noItems: PropTypes.string
};
